import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Icon,
  Dropdown,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const SubRepeaterPayMethodUX = (props: any) => {
    return(
      <div
        id="SubRepeaterPayMethodUX-div-0"
        style={{ height: "77.5px", width: "100%" }}>
        <Segment
          id="SubRepeaterPayMethodUX-Segment-1">
          <div
            id="SubRepeaterPayMethodUX-div-2"
            style={{display: "flex", alignItems: "center"}}>
            
            <div
              id="SubRepeaterPayMethodUX-div-3"
              style={{cursor: "pointer"}}>
              
              <Icon
                className="close red"
                id="SubRepeaterPayMethodUX-Icon-4"
                onClick={props.onClose}>
              </Icon>
            </div>
            <label
              id="SubRepeaterPayMethodUX-label-5"
              style={{padding: "0 10px", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "type" : "ประเภท"}
            </label>
            <Dropdown
              disabled={true}
              id="SubRepeaterPayMethodUX-Dropdown-6"
              options={[ { key: 2, text: "เงินโอน", value: 2 }, { key: 3, text: "บัตรเครดิต", value: 3 }, { key: 4, text: "เช็ค", value: 4 }, { key: 5, text: "คูปอง", value: 5 }, { key: 6, text: "กระเป๋าเงิน", value: 6 }, { key: 7, text: "ผ่อนชำระ", value: 7 }, { key: 9, text: "บัตรเดบิต", value: 9 }, ]}
              selection={true}
              value={props.type}>
            </Dropdown>
            <div
              id="SubRepeaterPayMethodUX-div-7"
              style={{display:  props.type === 2 ? "flex" : "none", alignItems: "center"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-8"
                style={{padding: "0 10px", fontWeight: "bold", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Reference number" : "เลขที่อ้างอิง"}
              </label>
              <Input
                id="SubRepeaterPayMethodUX-Input-9"
                name="paymentNo"
                onChange={props.onChange}
                value={props.paymentNo || ""}>
              </Input>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-10"
              style={{display:  props.type ===2 ? "flex" : "none", alignItems: "center"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-11"
                style={{padding: "0 10px", fontWeight: "bold", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Receivable Account" : "บัญชีรับ"}
              </label>
              <Dropdown
                id="SubRepeaterPayMethodUX-Dropdown-12"
                name="paymentTarget"
                onChange={props.onChange}
                options={props.masterAccountOptions}
                selection={true}
                value={props.paymentTarget || ""}>
              </Dropdown>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-13"
              style={{display:  [3,9].includes(props.type) ? "flex" : "none", alignItems: "center"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-14"
                style={{padding: "0 10px", fontWeight: "bold", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Card number" : "เลขบัตร"}
              </label>
              <Input
                className="payment_card_number-0"
                id="SubRepeaterPayMethodUX-Input-15"
                name="paymentNo.0"
                onChange={props.onChange}
                onKeyDown={props.handleKeyDownNumber}
                placeholder="xxxx"
                style={{width:"70px", marginRight: "10px"}}
                value={props.paymentNo?.[0] || ""}>
              </Input>
              <Input
                className="payment_card_number-1"
                id="SubRepeaterPayMethodUX-Input-16"
                name="paymentNo.1"
                onChange={props.onChange}
                onKeyDown={props.handleKeyDownNumber}
                placeholder="xxxx"
                style={{width:"70px", marginRight: "10px"}}
                value={props.paymentNo?.[1] || ""}>
              </Input>
              <Input
                className="payment_card_number-2"
                id="SubRepeaterPayMethodUX-Input-17"
                name="paymentNo.2"
                onChange={props.onChange}
                onKeyDown={props.handleKeyDownNumber}
                placeholder="xxxx"
                style={{width:"70px", marginRight: "10px"}}
                value={props.paymentNo?.[2] || ""}>
              </Input>
              <Input
                className="payment_card_number-3"
                id="SubRepeaterPayMethodUX-Input-18"
                name="paymentNo.3"
                onChange={props.onChange}
                onKeyDown={props.handleKeyDownNumber}
                placeholder="xxxx"
                style={{width:"70px", marginRight: "10px"}}
                value={props.paymentNo?.[3] || ""}>
              </Input>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-19"
              style={{display:  [3,9].includes(props.type) ? "flex" : "none",  alignItems: "center"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-20"
                style={{padding: "0 10px", fontWeight: "bold", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Swiping machine" : "เครื่องรูด"}
              </label>
              <Dropdown
                id="SubRepeaterPayMethodUX-Dropdown-21"
                name="paymentTarget"
                onChange={props.onChange}
                options={props.masterEDCOptions}
                selection={true}
                value={props.paymentTarget || ""}>
              </Dropdown>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-22"
              style={{display:   props.type ===4 ? "flex" : "none",  alignItems: "center", width: "100%"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-23"
                style={{padding: "0 10px", fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Check number" : "เลขเช็ค"}
              </label>
              <Input
                id="SubRepeaterPayMethodUX-Input-24"
                name="paymentNo"
                onChange={props.onChange}
                style={{ width: "50%" }}
                value={props.paymentNo || ""}>
              </Input>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-34"
              style={{display:   props.type ===4 ? "flex" : "none",  alignItems: "center", width: "100%"}}>
              
              <div
                id="SubRepeaterPayMethodUX-div-38"
                style={{ minWidth: "80px" }}>
                
                <label
                  id="SubRepeaterPayMethodUX-label-39"
                  style={{padding: "0 10px", fontWeight: "bold"}}>
                  วันที่เช็ค
                </label>
                <label
                  id="SubRepeaterPayMethodUX-label-40"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
              <DateTextBox
                id="SubRepeaterPayMethodUX-DateTextBox-36"
                onChange={props.onChangeDate}
                value={props.paymentDate}>
              </DateTextBox>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-25"
              style={{display:   props.type === 5 ? "flex" : "none",  alignItems: "center", width: "100%"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-26"
                style={{padding: "0 10px", fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Coupon number" : "เลขคูปอง"}
              </label>
              <Input
                className={props.couponMessage === "error" ? "error" : ""}
                icon={props.couponMessage === "success" ? "checkmark green" : ""}
                id="SubRepeaterPayMethodUX-Input-27"
                name="paymentNo"
                onChange={props.onChange}
                onKeyDown={props.onKeyDownCouponNumber}
                placeholder="กรอกเลขที่คูปองแล้วกด Enter"
                style={{width: "80%"}}
                value={props.paymentNo || ""}>
              </Input>
            </div>
            <div
              id="SubRepeaterPayMethodUX-div-28"
              style={{display:   props.type === 7 ? "flex" : "none",  alignItems: "center"}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-29"
                style={{padding: "0 10px", fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Contract number" : "เลขที่สัญญา"}
              </label>
              <Input
                id="SubRepeaterPayMethodUX-Input-30"
                name="paymentNo"
                onChange={props.onChange}
                value={props.paymentNo || ""}>
              </Input>
            </div>
            <div
              className="ui input"
              id="SubRepeaterPayMethodUX-div-31"
              style={{display:   "flex" , alignItems: "center", width:  [4, 5].includes(props.type) ? "100%" : ""}}>
              
              <label
                id="SubRepeaterPayMethodUX-label-32"
                style={{padding: "0 10px", fontWeight: "bold"}}>
                {props.languageUX === "en" ? "quantity" : "จำนวน"}
              </label>
              <Input
                disabled={props.type === 5}
                id="SubRepeaterPayMethodUX-Input-33"
                name="value"
                onChange={props.onChange}
                value={props.value || ""}>
              </Input>
            </div>
          </div>
        </Segment>
      </div>
    )
}


export default SubRepeaterPayMethodUX

export const screenPropsDefault = {}

/* Date Time : Tue Mar 17 2026 12:55:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"77.5px\", width: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Icon",
      "parent": 3,
      "props": {
        "className": {
          "type": "value",
          "value": "close red"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Icon-4"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท",
          "valueEN": "type"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-5"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Dropdown",
      "parent": 2,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Dropdown-6"
        },
        "options": {
          "type": "code",
          "value": "[ { key: 2, text: \"เงินโอน\", value: 2 }, { key: 3, text: \"บัตรเครดิต\", value: 3 }, { key: 4, text: \"เช็ค\", value: 4 }, { key: 5, text: \"คูปอง\", value: 5 }, { key: 6, text: \"กระเป๋าเงิน\", value: 6 }, { key: 7, text: \"ผ่อนชำระ\", value: 7 }, { key: 9, text: \"บัตรเดบิต\", value: 9 }, ]"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display:  props.type === 2 ? \"flex\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่อ้างอิง",
          "valueEN": "Reference number"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Input",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-9"
        },
        "name": {
          "type": "value",
          "value": "paymentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo || \"\""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{display:  props.type ===2 ? \"flex\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "บัญชีรับ",
          "valueEN": "Receivable Account"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-11"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Dropdown",
      "parent": 10,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Dropdown-12"
        },
        "name": {
          "type": "value",
          "value": "paymentTarget"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.masterAccountOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.paymentTarget || \"\""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{display:  [3,9].includes(props.type) ? \"flex\" : \"none\", alignItems: \"center\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขบัตร",
          "valueEN": "Card number"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-14"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Input",
      "parent": 13,
      "props": {
        "className": {
          "type": "value",
          "value": "payment_card_number-0"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-15"
        },
        "name": {
          "type": "value",
          "value": "paymentNo.0"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.handleKeyDownNumber"
        },
        "placeholder": {
          "type": "value",
          "value": "xxxx"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70px\", marginRight: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo?.[0] || \"\""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 13,
      "props": {
        "className": {
          "type": "value",
          "value": "payment_card_number-1"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-16"
        },
        "name": {
          "type": "value",
          "value": "paymentNo.1"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.handleKeyDownNumber"
        },
        "placeholder": {
          "type": "value",
          "value": "xxxx"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70px\", marginRight: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo?.[1] || \"\""
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Input",
      "parent": 13,
      "props": {
        "className": {
          "type": "value",
          "value": "payment_card_number-2"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-17"
        },
        "name": {
          "type": "value",
          "value": "paymentNo.2"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.handleKeyDownNumber"
        },
        "placeholder": {
          "type": "value",
          "value": "xxxx"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70px\", marginRight: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo?.[2] || \"\""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Input",
      "parent": 13,
      "props": {
        "className": {
          "type": "value",
          "value": "payment_card_number-3"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-18"
        },
        "name": {
          "type": "value",
          "value": "paymentNo.3"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.handleKeyDownNumber"
        },
        "placeholder": {
          "type": "value",
          "value": "xxxx"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70px\", marginRight: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo?.[3] || \"\""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{display:  [3,9].includes(props.type) ? \"flex\" : \"none\",  alignItems: \"center\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "เครื่องรูด",
          "valueEN": "Swiping machine"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-20"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Dropdown",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Dropdown-21"
        },
        "name": {
          "type": "value",
          "value": "paymentTarget"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "options": {
          "type": "code",
          "value": "props.masterEDCOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.paymentTarget || \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{display:   props.type ===4 ? \"flex\" : \"none\",  alignItems: \"center\", width: \"100%\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขเช็ค",
          "valueEN": "Check number"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 22,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-24"
        },
        "name": {
          "type": "value",
          "value": "paymentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo || \"\""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{display:   props.type === 5 ? \"flex\" : \"none\",  alignItems: \"center\", width: \"100%\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขคูปอง",
          "valueEN": "Coupon number"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-26"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Input",
      "parent": 25,
      "props": {
        "className": {
          "type": "code",
          "value": "props.couponMessage === \"error\" ? \"error\" : \"\""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "icon": {
          "type": "code",
          "value": "props.couponMessage === \"success\" ? \"checkmark green\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-27"
        },
        "name": {
          "type": "value",
          "value": "paymentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownCouponNumber"
        },
        "placeholder": {
          "type": "value",
          "value": "กรอกเลขที่คูปองแล้วกด Enter"
        },
        "style": {
          "type": "code",
          "value": "{width: \"80%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo || \"\""
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display:   props.type === 7 ? \"flex\" : \"none\",  alignItems: \"center\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่สัญญา",
          "valueEN": "Contract number"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-29"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-30"
        },
        "name": {
          "type": "value",
          "value": "paymentNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "value": {
          "type": "code",
          "value": "props.paymentNo || \"\""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui input"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display:   \"flex\" , alignItems: \"center\", width:  [4, 5].includes(props.type) ? \"100%\" : \"\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "quantity"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Input",
      "parent": 31,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.type === 5"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-Input-33"
        },
        "name": {
          "type": "value",
          "value": "value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChange"
        },
        "type": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.value || \"\""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{display:   props.type ===4 ? \"flex\" : \"none\",  alignItems: \"center\", width: \"100%\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 36,
      "name": "DateTextBox",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-DateTextBox-36"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.paymentDate"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"80px\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เช็ค"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-39"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 10px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "SubRepeaterPayMethodUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 40,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "SubRepeaterPayMethodUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
